import http from "./http";
import secureLocalStorage from "react-secure-storage";

const apiUrl = `${process.env.REACT_APP_API_URL}auth`;

export function getJWT() {
  return secureLocalStorage.getItem("accessToken");
}

export const isTokenValid = () => {
  const expiresAt = secureLocalStorage.getItem("expiresAt");
  if (!expiresAt) return false;

  const exp = Number(expiresAt);
  const currentTime = Math.floor(Date.now() / 1000);
  return exp > currentTime;
};

export function getUserLocal() {
  return secureLocalStorage.getItem("user");
}

export async function login(formData) {
  const {
    data: { payload: data },
  } = await http.post(`${apiUrl}/login`, formData);

  secureLocalStorage.setItem("user", data.user);
  secureLocalStorage.setItem("expiresIn", data.expires_in);
  secureLocalStorage.setItem("expiresAt", data.expires_at);
  secureLocalStorage.setItem("accessToken", data.access_token);

  return data;
}

export async function logout() {
  const result = await http.delete(`${apiUrl}/logout`);

  secureLocalStorage.removeItem("user");
  secureLocalStorage.removeItem("expiresAt");
  secureLocalStorage.removeItem("expiresIn");
  secureLocalStorage.removeItem("accessToken");


  return result;
}

export default {
  login,
  logout,
  getJWT,
  getUserLocal,
};
